const s3URL = 'https://public.cypherd.io/assets/static-cypherhq';

const Activate_CARD_BANNER = `${s3URL}/activateCardBanner.png`;
const Activate_CARD_STEP1 = `${s3URL}/activateCardStep1.png`;
const Activate_CARD_STEP2 = `${s3URL}/activateCardStep2.png`;
const Activate_CARD_STEP3 = `${s3URL}/activateCardStep3.png`;
const Activate_CARD_STEP4 = `${s3URL}/activateCardStep4.png`;
const Activate_CARD_STEP5 = `${s3URL}/activateCardStep5.png`;
const Activate_CARD_STEP6 = `${s3URL}/activateCardStep6.png`;
const Activate_CARD_STEP7 = `${s3URL}/activateCardStep7.png`;
const MOBILE_Activate_CARD_STEP1 = `${s3URL}/mobileActivateCardStep1.png`;
const MOBILE_Activate_CARD_STEP2 = `${s3URL}/mobileActivateCardStep2.png`;
const MOBILE_Activate_CARD_STEP3 = `${s3URL}/mobileActivateCardStep3.png`;
const MOBILE_Activate_CARD_STEP4 = `${s3URL}/mobileActivateCardStep4.png`;
const MOBILE_Activate_CARD_STEP5_1 = `${s3URL}/mobileActivateCardStep5_1.png`;
const MOBILE_Activate_CARD_STEP5_2 = `${s3URL}/mobileActivateCardStep5_2.png`;
const MOBILE_Activate_CARD_STEP6 = `${s3URL}/mobileActivateCardStep6.png`;
const MOBILE_Activate_CARD_STEP7_1 = `${s3URL}/mobileActivateCardStep7_1.png`;
const MOBILE_Activate_CARD_STEP7_2 = `${s3URL}/mobileActivateCardStep7_2.png`;
const THATS_IT = `${s3URL}/thatsIt.png`;
const CARDS_HERO_IMG = `${s3URL}/cardsHeroImg.png`;
const METAL_CARDS = `${s3URL}/metalCards.png`;
const CYPHER_BILL_PAYMENT = `${s3URL}/cypherBillPayment.png`;
const BLUE_CARD = `${s3URL}/blueCard.png`;
const CARD_ICON = `${s3URL}/cardIcon.png`;
const ANALYTICS_ICON = `${s3URL}/analyticsIcon.png`;
const FUND_CONTROL_ICON = `${s3URL}/fundControlIcon.png`;
const TAKADOA = `${s3URL}/takadoaLogo.png`;
const BENQI = `${s3URL}/benqiLogo.png`;
const TEGRO = `${s3URL}/tegroLogo.png`;
const SHARDEUM = `${s3URL}/shardeumLogo.png`;
const BANDIT = `${s3URL}/banditNeworkLogo.png`;
const WEAVE = `${s3URL}/weaveDBLogo.png`;
const GMX = `${s3URL}/gmxLogo.png`;
const ZEROXPPL = `${s3URL}/zeroXPplLogo.png`;
const DELTA_PRIME = `${s3URL}/deltaPrimeLogo.png`;
const CRYPTO_CARDS_BUNCH = `${s3URL}/cryptoCardsBunch.png`;
const DATA_VISUALISATION_LEFT = `${s3URL}/dataVisualisationLeft.png`;
const DATA_VISUALISATION_RIGHT = `${s3URL}/dataVisualisationRight.png`;
const EXPENSE_TRACKING = `${s3URL}/expenseTracking.svg`;
const SPEND_CARD_CONTROL = `${s3URL}/spendCardControl.svg`;
const SPEND_ANALYSIS = `${s3URL}/spendAnalysis.svg`;
const WIRE_TRANSFER = `${s3URL}/wireTransfer.svg`;
const REIMBURSEMENTS = `${s3URL}/reimbursementsDetail.svg`;
const GLOBAL_WIRE_TRANSFER = `${s3URL}/globalWireTransferDeatail.svg`;
const STABLE_COIN_OFF_RAMP = `${s3URL}/stableCoinOffRampDetail.svg`;
const USER_MANAGEMENT = `${s3URL}/userManagementDetail.svg`;
const ACCOUNT_INTEGRATION = `${s3URL}/accountIntegration.svg`;
const SIGNUP_SUCCESS = `${s3URL}/signupSuccess.png`;
const SWAP_BG = `${s3URL}/swapBg.svg`;
const YELLOW_CHECK_MARK = `${s3URL}/yellowCheckMark.svg`;
const WRONG_CIRCLE = `${s3URL}/wrongCircle.svg`;
const ETHEREUM = `${s3URL}/ethereum.svg`;
const COLLABORATION = `${s3URL}/collaboration.svg`;
const STARGAZE = `${s3URL}/stargaze.png`;
const POLYGON = `${s3URL}/polygon.svg`;
const OSMOSIS = `${s3URL}/osmosis.svg`;
const OPTIMISM = `${s3URL}/optimism.svg`;
const NOBLE = `${s3URL}/noble.svg`;
const MOONRIVER = `${s3URL}/moonRiver.svg`;
const MOONBEAM = `${s3URL}/moonBeam.svg`;
const FANTOM = `${s3URL}/fantom.svg`;
const EVMOS = `${s3URL}/evmos.png`;
const COREUM = `${s3URL}/coreum.svg`;
const BSC = `${s3URL}/bnb.svg`;
const BASE = `${s3URL}/base.png`;
const AVALANCHE = `${s3URL}/avax.svg`;
const COSMOS = `${s3URL}/atom.svg`;
const ARBITRUM = `${s3URL}/arbitrum.svg`;
const JUNO = `${s3URL}/juno.svg`;
const AURORA = `${s3URL}/aurora.svg`;
const ALERTS = `${s3URL}/alerts.svg`;

export const AppImages = {
  Activate_CARD_BANNER,
  Activate_CARD_STEP1,
  Activate_CARD_STEP2,
  Activate_CARD_STEP3,
  Activate_CARD_STEP4,
  Activate_CARD_STEP5,
  Activate_CARD_STEP6,
  Activate_CARD_STEP7,
  MOBILE_Activate_CARD_STEP1,
  MOBILE_Activate_CARD_STEP2,
  MOBILE_Activate_CARD_STEP3,
  MOBILE_Activate_CARD_STEP4,
  MOBILE_Activate_CARD_STEP5_1,
  MOBILE_Activate_CARD_STEP5_2,
  MOBILE_Activate_CARD_STEP6,
  MOBILE_Activate_CARD_STEP7_1,
  MOBILE_Activate_CARD_STEP7_2,
  THATS_IT,
  CARDS_HERO_IMG,
  METAL_CARDS,
  CYPHER_BILL_PAYMENT,
  BLUE_CARD,
  CARD_ICON,
  ANALYTICS_ICON,
  TAKADOA,
  BENQI,
  TEGRO,
  SHARDEUM,
  BANDIT,
  WEAVE,
  GMX,
  ZEROXPPL,
  DELTA_PRIME,
  CRYPTO_CARDS_BUNCH,
  DATA_VISUALISATION_LEFT,
  DATA_VISUALISATION_RIGHT,
  EXPENSE_TRACKING,
  SPEND_CARD_CONTROL,
  SPEND_ANALYSIS,
  WIRE_TRANSFER,
  REIMBURSEMENTS,
  GLOBAL_WIRE_TRANSFER,
  STABLE_COIN_OFF_RAMP,
  USER_MANAGEMENT,
  ACCOUNT_INTEGRATION,
  FUND_CONTROL_ICON,
  SIGNUP_SUCCESS,
  SWAP_BG,
  YELLOW_CHECK_MARK,
  WRONG_CIRCLE,
  ETHEREUM,
  COLLABORATION,
  AURORA,
  BASE,
  COREUM,
  OSMOSIS,
  POLYGON,
  COSMOS,
  BSC,
  OPTIMISM,
  ARBITRUM,
  NOBLE,
  FANTOM,
  AVALANCHE,
  JUNO,
  MOONBEAM,
  MOONRIVER,
  STARGAZE,
  EVMOS,
  ALERTS,
};
